var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',_vm._l((_vm.products),function(product){return _c('CCol',{key:product.id,staticClass:"mb-2",attrs:{"lg":"3","md":"4","col":"6","xxl":"2"}},[_c('SCardProduct',{attrs:{"product":product}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }